import { MUI_ICON_NAMES, MuiIconName } from "../generated/mui-icons";

const MUI_ICON_SET = new Set<string>(MUI_ICON_NAMES);

export function isMuiIconName(value: string): value is MuiIconName {
  return MUI_ICON_SET.has(value);
}